<template>
  <div class="profile-container rounded-4 shadow-sm p-4 bg-white">
    <div class="row">
      <!-- Côté gauche - Photo et actions -->
      <div class="col-md-4">
        <div class="profile-card text-center p-4 rounded-4 bg-light sticky-top" style="top: 80px;">
          <div class="profile-avatar mb-3">
            
            <img v-if="photo" :src="photo" class="rounded-circle img-fluid" alt="Photo de profil">
            <i v-else class="fas fa-user-circle fa-5x text-primary"></i>
            
            <input ref="fileInput" type="file" accept="image/*" @change="handlePhotoUpload" class="d-none">
          </div>
          <button @click="triggerFileInput" class="btn btn-sm btn-primary rounded-pill mt-2">
              <i class="fas fa-camera me-1"></i> Changer
            </button>
          <h3>{{ profile.name }}</h3>
          <p class="text-muted">{{ profile.job }}</p>

          <div class="d-grid gap-2 mt-3">
              <!-- <button class="btn btn-outline-primary rounded-pill">
                <i class="fas fa-file-pdf me-2"></i> Exporter en PDF
              </button>  -->
             <!-- <button type="button" v-if="profile.slug" class="btn btn-outline-secondary rounded-pill" @click="goToVitrine">
              <i class="fas fa-copy me-2"></i> Copier le lien de ma vitrine
            </button> -->
            <a v-if="profile.slug && completionRate > 50" :href="this.$store.getters.apiUrl + '/pro/'+profile.slug" class="btn btn-outline-secondary rounded-pill" target="_blank">
              <i class="fas fa-eye me-2"></i> Prévisualiser ma vitrine
            </a> 
          </div>

          <div class="mt-4 text-start">
            <h5><i class="fas fa-percentage me-2"></i>Profil complété</h5>
            <div class="progress rounded-pill" style="height: 10px;">
              <div class="progress-bar bg-success" role="progressbar" :style="`width: ${completionRate}%`"></div>
            </div>
            <small class="text-muted">{{ completionRate }}% complet</small>
          </div>
        </div>
      </div>

      <!-- Côté droit - Sections du CV -->
      <div class="col-md-8">
        <!-- Bio / À propos -->
        <div class="section-card mb-4 p-4 rounded-4 bg-light">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h3><i class="fas fa-user-edit me-2"></i>À propos</h3>
            <button class="btn btn-sm btn-outline-primary" @click="toggleEdit('bio')">
              <i class="fas" :class="editing.bio ? 'fa-check' : 'fa-pencil-alt'"></i>
            </button>
          </div>

          <form v-if="editing.bio" @submit.prevent="saveSection('bio')">
            <div class="mb-3">
              <label class="form-label">Titre professionnel</label>
              <input v-model="profile.job" type="text" class="form-control rounded-3"
                placeholder="Développeur Full Stack">
            </div>
            <div class="mb-3">
              <label class="form-label">Bio</label>
              <textarea v-model="profile.bio" class="form-control rounded-3" rows="4"
                placeholder="Décrivez-vous en quelques mots..."></textarea>
            </div>
            <button type="submit" class="btn btn-primary btn-sm rounded-pill">Enregistrer</button>
          </form>
          <div v-else>
            <h5 class="text-primary">{{ profile.job }}</h5>
            <p class="pre-formatted">{{ profile.bio || "Aucune description fournie" }}</p>
          </div>
        </div>

        <!-- Informations personnelles -->
        <div class="section-card mb-4 p-4 rounded-4 bg-light">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h3><i class="fas fa-info-circle me-2"></i>Informations personnelles</h3>
            <button class="btn btn-sm btn-outline-primary" @click="toggleEdit('personal')">
              <i class="fas" :class="editing.personal ? 'fa-check' : 'fa-pencil-alt'"></i>
            </button>
          </div>

          <form v-if="editing.personal" @submit.prevent="saveSection('personal')">
            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label">Nom complet</label>
                <input v-model="profile.name" type="text" class="form-control rounded-3" required>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">Email</label>
                <input v-model="profile.email" type="email" class="form-control rounded-3" disabled>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label">Téléphone</label>
                <input v-model="profile.phone" type="tel" class="form-control rounded-3">
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">Date de naissance</label>
                <input v-model="profile.birthdate" type="date" class="form-control rounded-3">
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label">Nationalité</label>
                <input v-model="profile.nationality" type="text" class="form-control rounded-3">
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">Situation</label>
                <select v-model="profile.maritalStatus" class="form-select rounded-3">
                  <option value="">Sélectionner</option>
                  <option value="single">Célibataire</option>
                  <option value="married">Marié(e)</option>
                  <option value="divorced">Divorcé(e)</option>
                </select>
              </div>
            </div>
            <button type="submit" class="btn btn-primary btn-sm rounded-pill">Enregistrer</button>
          </form>
          <div v-else class="row">
            <div class="col-6 col-md-4 mb-2">
              <label class="form-label small text-muted">Nom complet</label>
              <p>{{ profile.name }}</p>
            </div>
            <div class="col-6 col-md-4 mb-2">
              <label class="form-label small text-muted">Email</label>
              <p>{{ profile.email }}</p>
            </div>
            <div class="col-6 col-md-4 mb-2">
              <label class="form-label small text-muted">Téléphone</label>
              <p>{{ profile.phone || 'Non renseigné' }}</p>
            </div>
            <div class="col-6 col-md-4 mb-2">
              <label class="form-label small text-muted">Date de naissance</label>
              <p>{{ profile.birthdate ? formatDate(profile.birthdate) : 'Non renseignée' }}</p>
            </div>
            <div class="col-6 col-md-4 mb-2">
              <label class="form-label small text-muted">Nationalité</label>
              <p>{{ profile.nationality || 'Non renseignée' }}</p>
            </div>
            <div class="col-6 col-md-4 mb-2">
              <label class="form-label small text-muted">Situation</label>
              <p>{{ maritalStatusText }}</p>
            </div>
          </div>
        </div>

        <!-- Adresse -->
        <div class="section-card mb-4 p-4 rounded-4 bg-light">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h3><i class="fas fa-map-marker-alt me-2"></i>Adresse</h3>
            <button class="btn btn-sm btn-outline-primary" @click="toggleEdit('address')">
              <i class="fas" :class="editing.address ? 'fa-check' : 'fa-pencil-alt'"></i>
            </button>
          </div>

          <form v-if="editing.address" @submit.prevent="saveSection('address')">
            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label">Adresse</label>
                <input v-model="profile.address" type="text" class="form-control rounded-3">
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">Complément</label>
                <input v-model="profile.address2" type="text" class="form-control rounded-3">
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 mb-3">
                <label class="form-label">Code postal</label>
                <input v-model="profile.postalCode" type="text" class="form-control rounded-3">
              </div>
              <div class="col-md-4 mb-3">
                <label class="form-label">Ville</label>
                <input v-model="profile.city" type="text" class="form-control rounded-3">
              </div>
              <div class="col-md-4 mb-3">
                <label class="form-label">Pays</label>
                <input v-model="profile.country" type="text" class="form-control rounded-3">
              </div>
            </div>
            <button type="submit" class="btn btn-primary btn-sm rounded-pill">Enregistrer</button>
          </form>
          <div v-else>
            <p v-if="profile.address">{{ profile.address }}{{ profile.address2 ? ', ' + profile.address2 : '' }}</p>
            <p v-if="profile.city">{{ profile.postalCode }} {{ profile.city }}</p>
            <p v-if="profile.country">{{ profile.country }}</p>
            <p v-if="!profile.address && !profile.city && !profile.country">Aucune adresse renseignée</p>
          </div>
        </div>

        <!-- Expériences professionnelles -->
        <div class="section-card mb-4 p-4 rounded-4 bg-light">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h3><i class="fas fa-briefcase me-2"></i>Expériences professionnelles</h3>
            <button class="btn btn-sm btn-primary rounded-pill" @click="addExperience">
              <i class="fas fa-plus me-1"></i> Ajouter
            </button>
          </div>

          <div v-if="profile.experiences.length === 0" class="alert alert-info rounded-3">
            <i class="fas fa-info-circle me-2"></i>Aucune expérience professionnelle enregistrée
          </div>

          <div v-else>
            <div v-for="(exp, index) in profile.experiences" :key="index"
              class="experience-item mb-4 p-3 rounded-3 bg-white">
              <div class="d-flex justify-content-between align-items-start">
                <div>
                  <h5 class="mb-1">{{ exp.jobTitle }}</h5>
                  <p class="mb-1 text-primary">{{ exp.company }}</p>
                  <p class="small text-muted mb-1">
                    {{ formatDate(exp.startDate) }} - {{ exp.current ? 'Présent' : formatDate(exp.endDate) }}
                  </p>
                </div>
                <div class="btn-group">
                  <button class="btn btn-sm btn-outline-secondary" @click="editExperience(index)">
                    <i class="fas fa-edit"></i>
                  </button>
                  <button class="btn btn-sm btn-outline-danger" @click="removeExperience(index)">
                    <i class="fas fa-trash-alt"></i>
                  </button>
                </div>
              </div>
              <p class="mb-0 mt-2 pre-formatted">{{ exp.description }}</p>

              <!-- Formulaire d'édition -->
              <form v-if="exp.editing" @submit.prevent="saveExperience(index)" class="mt-3">
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <label class="form-label">Poste</label>
                    <input v-model="exp.jobTitle" type="text" class="form-control rounded-3" required>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label">Entreprise</label>
                    <input v-model="exp.company" type="text" class="form-control rounded-3" required>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4 mb-3">
                    <label class="form-label">Date de début</label>
                    <input v-model="exp.startDate" type="date" class="form-control rounded-3" required>
                  </div>
                  <div class="col-md-4 mb-3">
                    <label class="form-label">Date de fin</label>
                    <input v-model="exp.endDate" type="date" class="form-control rounded-3" :disabled="exp.current">
                  </div>
                  <div class="col-md-4 mb-3 d-flex align-items-end">
                    <div class="form-check">
                      <input v-model="exp.current" type="checkbox" class="form-check-input" id="currentJob">
                      <label class="form-check-label" for="currentJob">Poste actuel</label>
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <label class="form-label">Description</label>
                  <textarea v-model="exp.description" class="form-control rounded-3" rows="3"></textarea>
                </div>
                <button type="submit" class="btn btn-primary btn-sm rounded-pill me-2">Enregistrer</button>
                <button type="button" class="btn btn-outline-secondary btn-sm rounded-pill"
                  @click="cancelEditExperience(index)">Annuler</button>
              </form>
            </div>
          </div>
        </div>

        <!-- Formations -->
        <div class="section-card mb-4 p-4 rounded-4 bg-light">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h3><i class="fas fa-graduation-cap me-2"></i>Formations</h3>
            <button class="btn btn-sm btn-primary rounded-pill" @click="addEducation">
              <i class="fas fa-plus me-1"></i> Ajouter
            </button>
          </div>

          <div v-if="profile.educations.length === 0" class="alert alert-info rounded-3">
            <i class="fas fa-info-circle me-2"></i>Aucune formation enregistrée
          </div>

          <div v-else>
            <div v-for="(edu, index) in profile.educations" :key="index"
              class="education-item mb-4 p-3 rounded-3 bg-white">
              <div class="d-flex justify-content-between align-items-start">
                <div>
                  <h5 class="mb-1">{{ edu.degree }}</h5>
                  <p class="mb-1 text-primary">{{ edu.school }}</p>
                  <p class="small text-muted mb-1">
                    {{ formatDate(edu.startDate) }} - {{ edu.current ? 'En cours' : formatDate(edu.endDate) }}
                  </p>
                </div>
                <div class="btn-group">
                  <button class="btn btn-sm btn-outline-secondary" @click="editEducation(index)">
                    <i class="fas fa-edit"></i>
                  </button>
                  <button class="btn btn-sm btn-outline-danger" @click="removeEducation(index)">
                    <i class="fas fa-trash-alt"></i>
                  </button>
                </div>
              </div>
              <p class="mb-0 mt-2 pre-formatted">{{ edu.description }}</p>

              <!-- Formulaire d'édition -->
              <form v-if="edu.editing" @submit.prevent="saveEducation(index)" class="mt-3">
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <label class="form-label">Diplôme</label>
                    <input v-model="edu.degree" type="text" class="form-control rounded-3" required>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label">Établissement</label>
                    <input v-model="edu.school" type="text" class="form-control rounded-3" required>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4 mb-3">
                    <label class="form-label">Date de début</label>
                    <input v-model="edu.startDate" type="date" class="form-control rounded-3" required>
                  </div>
                  <div class="col-md-4 mb-3">
                    <label class="form-label">Date de fin</label>
                    <input v-model="edu.endDate" type="date" class="form-control rounded-3" :disabled="edu.current">
                  </div>
                  <div class="col-md-4 mb-3 d-flex align-items-end">
                    <div class="form-check">
                      <input v-model="edu.current" type="checkbox" class="form-check-input" id="currentEducation">
                      <label class="form-check-label" for="currentEducation">En cours</label>
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <label class="form-label">Description</label>
                  <textarea v-model="edu.description" class="form-control rounded-3" rows="3"></textarea>
                </div>
                <button type="submit" class="btn btn-primary btn-sm rounded-pill me-2">Enregistrer</button>
                <button type="button" class="btn btn-outline-secondary btn-sm rounded-pill"
                  @click="cancelEditEducation(index)">Annuler</button>
              </form>
            </div>
          </div>
        </div>

        <!-- Compétences -->
        <div class="section-card mb-4 p-4 rounded-4 bg-light">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h3><i class="fas fa-code me-2"></i>Compétences</h3>
            <button class="btn btn-sm btn-primary rounded-pill" @click="addSkill">
              <i class="fas fa-plus me-1"></i> Ajouter
            </button>
          </div>

          <div v-if="profile.skills.length === 0" class="alert alert-info rounded-3">
            <i class="fas fa-info-circle me-2"></i>Aucune compétence enregistrée
          </div>

          <div v-else>
            <div class="skills-container">
              <div v-for="(skill, index) in profile.skills" :key="index" class="skill-item p-3 rounded-3 bg-white mb-3">
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <h6 class="mb-1">{{ skill.name }}</h6>
                    <div class="progress myprogress rounded-pill" style="height: 8px;">
                      <div class="progress-bar bg-primary" :style="`width: ${skill.level}%`"></div>
                    </div>
                    <small class="text-muted">{{ skillLevelText(skill.level) }}</small>
                  </div>
                  <div class="btn-group">
                    <button class="btn btn-sm btn-outline-secondary" @click="editSkill(index)">
                      <i class="fas fa-edit"></i>
                    </button>
                    <button class="btn btn-sm btn-outline-danger" @click="removeSkill(index)">
                      <i class="fas fa-trash-alt"></i>
                    </button>
                  </div>
                </div>

                <!-- Formulaire d'édition -->
                <form v-if="skill.editing" @submit.prevent="saveSkill(index)" class="mt-3">
                  <div class="row">
                    <div class="col-md-8 mb-3">
                      <label class="form-label">Compétence</label>
                      <input v-model="skill.name" type="text" class="form-control rounded-3" required>
                    </div>
                    <div class="col-md-4 mb-3">
                      <label class="form-label">Niveau ({{ skill.level }}%)</label>
                      <input v-model="skill.level" type="range" class="form-range" min="0" max="100" step="5">
                    </div>
                  </div>
                  <button type="submit" class="btn btn-primary btn-sm rounded-pill me-2">Enregistrer</button>
                  <button type="button" class="btn btn-outline-secondary btn-sm rounded-pill"
                    @click="cancelEditSkill(index)">Annuler</button>
                </form>
              </div>
            </div>
          </div>
        </div>

        <!-- Langues -->
        <div class="section-card mb-4 p-4 rounded-4 bg-light">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h3><i class="fas fa-language me-2"></i>Langues</h3>
            <button class="btn btn-sm btn-primary rounded-pill" @click="addLanguage">
              <i class="fas fa-plus me-1"></i> Ajouter
            </button>
          </div>

          <div v-if="profile.languages.length === 0" class="alert alert-info rounded-3">
            <i class="fas fa-info-circle me-2"></i>Aucune langue enregistrée
          </div>

          <div v-else>
            <div class="languages-container">
              <div v-for="(lang, index) in profile.languages" :key="index"
                class="language-item p-3 rounded-3 bg-white mb-3">
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <h6 class="mb-1">{{ lang.name }}</h6>
                    <div class="progress myprogress rounded-pill" style="height: 8px;">
                      <div class="progress-bar bg-info" :style="`width: ${lang.level}%`"></div>
                    </div>
                    <small class="text-muted">{{ languageLevelText(lang.level) }}</small>
                  </div>
                  <div class="btn-group">
                    <button class="btn btn-sm btn-outline-secondary" @click="editLanguage(index)">
                      <i class="fas fa-edit"></i>
                    </button>
                    <button class="btn btn-sm btn-outline-danger" @click="removeLanguage(index)">
                      <i class="fas fa-trash-alt"></i>
                    </button>
                  </div>
                </div>

                <!-- Formulaire d'édition -->
                <form v-if="lang.editing" @submit.prevent="saveLanguage(index)" class="mt-3">
                  <div class="row">
                    <div class="col-md-6 mb-3">
                      <label class="form-label">Langue</label>
                      <input v-model="lang.name" type="text" class="form-control rounded-3" required>
                    </div>
                    <div class="col-md-6 mb-3">
                      <label class="form-label">Niveau</label>
                      <select v-model="lang.level" class="form-select rounded-3">
                        <option value="20">Débutant</option>
                        <option value="40">Intermédiaire</option>
                        <option value="60">Avancé</option>
                        <option value="80">Courant</option>
                        <option value="100">Bilingue</option>
                      </select>
                    </div>
                  </div>
                  <button type="submit" class="btn btn-primary btn-sm rounded-pill me-2">Enregistrer</button>
                  <button type="button" class="btn btn-outline-secondary btn-sm rounded-pill"
                    @click="cancelEditLanguage(index)">Annuler</button>
                </form>
              </div>
            </div>
          </div>
        </div>

        <!-- Certifications -->
        <div class="section-card mb-4 p-4 rounded-4 bg-light">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h3><i class="fas fa-certificate me-2"></i>Certifications</h3>
            <button class="btn btn-sm btn-primary rounded-pill" @click="addCertification">
              <i class="fas fa-plus me-1"></i> Ajouter
            </button>
          </div>

          <div v-if="profile.certifications.length === 0" class="alert alert-info rounded-3">
            <i class="fas fa-info-circle me-2"></i>Aucune certification enregistrée
          </div>

          <div v-else>
            <div v-for="(cert, index) in profile.certifications" :key="index"
              class="certification-item mb-4 p-3 rounded-3 bg-white">
              <div class="d-flex justify-content-between align-items-start">
                <div>
                  <h5 class="mb-1">{{ cert.name }}</h5>
                  <p class="mb-1 text-primary">{{ cert.organization }}</p>
                  <p class="small text-muted mb-1">
                    Obtenue le {{ formatDate(cert.date) }} -
                    <span v-if="cert.expirationDate">Expire le {{ formatDate(cert.expirationDate) }}</span>
                    <span v-else>Pas de date d'expiration</span>
                  </p>
                  <p v-if="cert.credentialId" class="small text-muted mb-1">ID: {{ cert.credentialId }}</p>
                </div>
                <div class="btn-group">
                  <button class="btn btn-sm btn-outline-secondary" @click="editCertification(index)">
                    <i class="fas fa-edit"></i>
                  </button>
                  <button class="btn btn-sm btn-outline-danger" @click="removeCertification(index)">
                    <i class="fas fa-trash-alt"></i>
                  </button>
                </div>
              </div>

              <!-- Formulaire d'édition -->
              <form v-if="cert.editing" @submit.prevent="saveCertification(index)" class="mt-3">
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <label class="form-label">Nom de la certification</label>
                    <input v-model="cert.name" type="text" class="form-control rounded-3" required>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label">Organisme</label>
                    <input v-model="cert.organization" type="text" class="form-control rounded-3" required>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4 mb-3">
                    <label class="form-label">Date d'obtention</label>
                    <input v-model="cert.date" type="date" class="form-control rounded-3" required>
                  </div>
                  <div class="col-md-4 mb-3">
                    <label class="form-label">Date d'expiration</label>
                    <input v-model="cert.expirationDate" type="date" class="form-control rounded-3">
                  </div>
                  <div class="col-md-4 mb-3">
                    <label class="form-label">Identifiant</label>
                    <input v-model="cert.credentialId" type="text" class="form-control rounded-3">
                  </div>
                </div>
                <button type="submit" class="btn btn-primary btn-sm rounded-pill me-2">Enregistrer</button>
                <button type="button" class="btn btn-outline-secondary btn-sm rounded-pill"
                  @click="cancelEditCertification(index)">Annuler</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProfileView',
  data() {
    return {
      isLoading: false,
      editing: {
        bio: false,
        personal: false,
        address: false
      },
      photo: null,
      profile: {
        photo: null,
        nouvelle_photo: null,
        name: null,
        job: null,
        email: null,
        phone: null,
        birthdate: null,
        nationality: null,
        maritalStatus: null,
        bio: null,
        address: null,
        address2: null,
        postalCode: null,
        city: null,
        country: null,
        experiences: [],
        educations: [],
        skills: [],
        languages: [],
        certifications: []
      }
    }
  },
  mounted() {
    this.getMembershipDatas()
  },
  computed: {
    completionRate() {
      let filledFields = 0
      const totalFields = 20 // Nombre total de champs importants

      // Vérification des champs de base
      if (this.profile.name) filledFields++
      if (this.profile.email) filledFields++
      if (this.profile.job) filledFields++
      if (this.profile.bio) filledFields++
      if (this.profile.phone) filledFields++
      if (this.profile.address) filledFields++
      if (this.profile.city) filledFields++
      if (this.profile.country) filledFields++

      // Ajout pour les sections dynamiques
      if (this.profile.experiences.length > 0) filledFields += 2
      if (this.profile.educations.length > 0) filledFields += 2
      if (this.profile.skills.length > 0) filledFields += 2
      if (this.profile.languages.length > 0) filledFields += 2
      if (this.profile.certifications.length > 0) filledFields += 2

      return Math.round((filledFields / totalFields) * 100)
    },
    maritalStatusText() {
      const statusMap = {
        single: 'Célibataire',
        married: 'Marié(e)',
        divorced: 'Divorcé(e)'
      }
      return this.profile.maritalStatus ? statusMap[this.profile.maritalStatus] : 'Non renseigné'
    }
  },
  methods: {
    getMembershipDatas() {
      const membership = this.$store.getters.membership
      this.photo = membership.photo ? membership.photo : null,
      this.profile = {
        slug: membership.slug ? membership.slug : null,
        photo: membership.photo ? membership.photo : null,
        name: membership.nom_complet ? membership.nom_complet : null,
        job: membership.titre_pro ? membership.titre_pro : null,
        email: membership.email ? membership.email : null,
        phone: membership.telephone ? membership.telephone : null,
        birthdate: membership.date_naissance ? membership.date_naissance : null,
        nationality: membership.nationalite ? membership.nationalite : null,
        maritalStatus: membership.situation_matri ? membership.situation_matri : null,
        bio: membership.bio ? membership.bio : null,
        address: membership.adresse ? membership.adresse : null,
        address2: membership.adresse_complement ? membership.adresse_complement : null,
        postalCode: membership.bp ? membership.bp : null,
        city: membership.ville ? membership.ville : null,
        country: membership.pays ? membership.pays : null,
        experiences: membership.experiences_pro ? membership.experiences_pro : [],
        educations: membership.formations ? membership.formations : [],
        skills: membership.competences ? membership.competences : [],
        languages: membership.langues ? membership.langues : [],
        certifications: membership.certifications ? membership.certifications : [],
        realisations: membership.realisations ? membership.realisations : [],
      }

      this.profile.experiences.forEach(element => {
        element.editing = false
      });

      this.profile.certifications.forEach(element => {
        element.editing = false
      });

      this.profile.educations.forEach(element => {
        element.editing = false
      });

      this.profile.skills.forEach(element => {
        element.editing = false
      });

      this.profile.languages.forEach(element => {
        element.editing = false
      });

      this.profile.realisations.forEach(element => {
        element.editing = false
      });
      
    },
    toggleEdit(section) {
      this.editing[section] = !this.editing[section]
    },
    async saveSection(section = null) {
      this.isLoading = true
      await this.axios.post(`/api/membership/${this.$store.getters.membership.id}/update`, this.profile, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(response => {
        this.isLoading = false
        if (response.data.success === true) {
          if (section) this.editing[section] = false;
          this.$store.commit('setMembership', response.data.data);
          this.$toast.add({
            severity: 'success',
            detail: response.data.message || 'Opération réussie',
            life: 3000
          });
        } else {
          const errors = response.data.errors || ['Une erreur est survenue'];
          if (Array.isArray(errors)) {
            errors.forEach(element => {
              this.$toast.add({
                severity: 'warn',
                summary: 'Oups !',
                detail: element,
                life: 7000
              });
            });
          }
        }
      }).catch(error => {
        this.isLoading = false
        this.$toast.add({
          severity: 'error',
          summary: 'Problème de connexion',
          detail: 'Une erreur s\'est produite lors de la connexion au serveur !',
          life: 5000
        });
        console.error(error);
      })
    },
    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleDateString('fr-FR')
    },
    skillLevelText(level) {
      if (level >= 90) return 'Expert'
      if (level >= 70) return 'Avancé'
      if (level >= 50) return 'Intermédiaire'
      if (level >= 30) return 'Débutant'
      return 'Novice'
    },
    languageLevelText(level) {
      if (level >= 80) return 'Courant'
      if (level >= 60) return 'Avancé'
      if (level >= 40) return 'Intermédiaire'
      return 'Débutant'
    },
    triggerFileInput() {
      this.$refs.fileInput.click()
    },
    handlePhotoUpload(event) {
      const file = event.target.files[0]
      if (file) {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.photo = e.target.result
          this.profile.nouvelle_photo = event.target.files[0]
          this.saveSection()
        }
        reader.readAsDataURL(file)
      }
      
    },
    // Méthodes pour les expériences
    addExperience() {
      this.profile.experiences.unshift({
        jobTitle: '',
        company: '',
        startDate: '',
        endDate: '',
        current: false,
        description: '',
        editing: true
      })
    },
    editExperience(index) {
      this.profile.experiences.forEach((exp, i) => {
        exp.editing = i === index
      })
    },
    saveExperience(index) {
      this.profile.experiences[index].editing = false
      this.saveSection()
    },
    cancelEditExperience(index) {
      if (!this.profile.experiences[index].jobTitle) {
        this.profile.experiences.splice(index, 1)
      } else {
        this.profile.experiences[index].editing = false
      }
    },
    removeExperience(index) {
      if (confirm('Supprimer cette expérience?')) {
        this.profile.experiences.splice(index, 1)
        this.saveSection()
      }
    },

    // Méthodes pour les formations
    addEducation() {
      this.profile.educations.unshift({
        degree: '',
        school: '',
        startDate: '',
        endDate: '',
        current: false,
        description: '',
        editing: true
      })
    },
    editEducation(index) {
      this.profile.educations.forEach((edu, i) => {
        edu.editing = i === index
      })
    },
    saveEducation(index) {
      this.profile.educations[index].editing = false
      this.saveSection()
    },
    cancelEditEducation(index) {
      if (!this.profile.educations[index].degree) {
        this.profile.educations.splice(index, 1)
      } else {
        this.profile.educations[index].editing = false
      }
    },
    removeEducation(index) {
      if (confirm('Supprimer cette formation?')) {
        this.profile.educations.splice(index, 1)
        this.saveSection()
      }
    },

    // Méthodes pour les compétences
    addSkill() {
      this.profile.skills.unshift({
        name: '',
        level: 50,
        editing: true
      })
    },
    editSkill(index) {
      this.profile.skills.forEach((skill, i) => {
        skill.editing = i === index
      })
    },
    saveSkill(index) {
      this.profile.skills[index].editing = false
      this.saveSection()
    },
    cancelEditSkill(index) {
      if (!this.profile.skills[index].name) {
        this.profile.skills.splice(index, 1)
      } else {
        this.profile.skills[index].editing = false
      }
    },
    removeSkill(index) {
      if (confirm('Supprimer cette compétence?')) {
        this.profile.skills.splice(index, 1)
        this.saveSection()
      }
    },

    // Méthodes pour les langues
    addLanguage() {
      this.profile.languages.unshift({
        name: '',
        level: 40,
        editing: true
      })
    },
    editLanguage(index) {
      this.profile.languages.forEach((lang, i) => {
        lang.editing = i === index
      })
    },
    saveLanguage(index) {
      this.profile.languages[index].editing = false
      this.saveSection()
    },
    cancelEditLanguage(index) {
      if (!this.profile.languages[index].name) {
        this.profile.languages.splice(index, 1)
      } else {
        this.profile.languages[index].editing = false
      }
    },
    removeLanguage(index) {
      if (confirm('Supprimer cette langue?')) {
        this.profile.languages.splice(index, 1)
        this.saveSection()
      }
    },

    // Méthodes pour les certifications
    addCertification() {
      this.profile.certifications.unshift({
        name: '',
        organization: '',
        date: '',
        expirationDate: '',
        credentialId: '',
        editing: true
      })
    },
    editCertification(index) {
      this.profile.certifications.forEach((cert, i) => {
        cert.editing = i === index
      })
    },
    saveCertification(index) {
      this.profile.certifications[index].editing = false
      this.saveSection()
    },
    cancelEditCertification(index) {
      if (!this.profile.certifications[index].name) {
        this.profile.certifications.splice(index, 1)
      } else {
        this.profile.certifications[index].editing = false
      }
    },
    removeCertification(index) {
      if (confirm('Supprimer cette certification?')) {
        this.profile.certifications.splice(index, 1)
        this.saveSection()
      }
    }
  }
}
</script>

<style scoped>
.profile-container {
  max-width: 1200px;
  margin: 0 auto;
}

.profile-card {
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.05);
}

.profile-avatar {
  margin: 0 auto;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 5px solid white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.profile-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.section-card {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
  transition: all 0.3s;
}

.section-card:hover {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.pre-formatted {
  white-space: pre-wrap;
}

.experience-item,
.education-item,
.certification-item {
  transition: all 0.3s;
  border-left: 4px solid var(--bs-primary);
}

.experience-item:hover,
.education-item:hover,
.certification-item:hover {
  transform: translateX(5px);
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
}

.skill-item,
.language-item {
  transition: all 0.3s;
  border-left: 4px solid var(--bs-info);
}

.skill-item:hover,
.language-item:hover {
  transform: translateX(5px);
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
}

.sticky-top {
  position: sticky;
  z-index: 1020;
}

.form-range::-webkit-slider-thumb {
  background: var(--bs-primary);
}

.form-range::-moz-range-thumb {
  background: var(--bs-primary);
}

.form-range::-ms-thumb {
  background: var(--bs-primary);
}

.myprogress {
  width: 10rem !important;
  max-width: 10rem !important;
}
</style>